import { useScriptTag } from '@vueuse/core';
import { storeToRefs, useTenantStore } from '@star/stores';

export default function useScript() {
  const { cfg51la, isRepairing } = storeToRefs(useTenantStore());
  const src = `${window.location.protocol}//sdk.51.la/js-sdk-pro.min.js`;

  const { load: load51laScript, unload } = useScriptTag(
    src,
    (el: HTMLScriptElement) => {
      window.LA?.init({ ...cfg51la.value });
      console.log(window.LA, '---- window.LA ----');
    },
    { manual: true, attrs: { id: 'LA_COLLECT', charset: 'UTF-8' } }
  );

  const initScript = () => {
    if (isRepairing.value) return;
    if (!!cfg51la.value?.id && !!cfg51la.value?.ck) {
      load51laScript();
    }
  };

  return {
    initScript,
  };
}
